import { AnimatePresence, m } from "framer-motion";
import { authClient } from "../../lib/auth-client";
import { capitalizeName } from "../../lib/format";

interface ImpersonationBannerProps {
	isImpersonating: boolean;
	user: {
		id: string;
		name?: string | null;
		email?: string;
	};
}

export function ImpersonationBanner({
	isImpersonating,
	user,
}: ImpersonationBannerProps) {
	const handleStopImpersonating = async () => {
		try {
			const result = await authClient.admin.stopImpersonating();
			if (result.error) {
				console.error("Stop impersonating failed:", result.error);
			}
		} catch (error) {
			console.error("Stop impersonating error:", error);
		}
		window.location.href = "/admin/users";
	};

	return (
		<AnimatePresence>
			{isImpersonating && (
				<div className="max-w-7xl mx-auto mb-2">
					<m.div
						initial={{ height: 0, opacity: 0 }}
						animate={{ height: "auto", opacity: 1 }}
						exit={{ height: 0, opacity: 0 }}
						transition={{ duration: 0.2, ease: "easeOut" }}
						className="overflow-hidden rounded-2xl border border-amber-500/25 bg-amber-500/10"
					>
						<div className="px-4 sm:px-6">
							<div className="h-10 flex items-center justify-between">
								<div className="flex items-center gap-2 text-sm text-amber-700 dark:text-amber-400">
									<div className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
									Impersonating{" "}
									<span className="font-semibold">
										{user.email || capitalizeName(user.name) || user.id}
									</span>
								</div>
								<button
									type="button"
									onClick={handleStopImpersonating}
									className="text-sm font-medium text-amber-700 dark:text-amber-400 hover:text-amber-800 dark:hover:text-amber-300 transition-colors"
								>
									&larr; Back to admin
								</button>
							</div>
						</div>
					</m.div>
				</div>
			)}
		</AnimatePresence>
	);
}
